module.exports = __webpack_public_path__ + "img/business-icon-10.bebe1acc.png";